import { Box, Form, Loader, ModBox, TextNew } from '@jfs/ui-new'
import { useStores } from '../../../../data/store'
import { riskSettingsForm } from './form'
const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const RiskSettings = ({ isEdit, isSearchFlow, selectedEntity }: any) => {
  console.log(' RiskSettings isEdit', isEdit, isSearchFlow)

  const { getMasEntityRiskSettingsData } = useStores((store) => ({
    getMasEntityRiskSettingsData: store.getMasEntityRiskSettingsData,
  }))

  return (
    <Box f={1} overflow={'auto'} pv={32}>
      <ModBox show={false}>
        <Loader type={'large'} color={'PRIMARY'} />
      </ModBox>
      <ModBox show={true}>
        <Form
          formData={riskSettingsForm(
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'TIP'),
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'DELIVERY_PERIOD'),
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'INTERNATIONAL_ACCEPTANCE'),
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'REFUND'),
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'ADDITIONAL_REFUND_PERCENTAGE'),
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'OPEN_LOOP_REFUND_EXIT_LIMIT'),
            getMasEntityRiskSettingsData(selectedEntity?.id, 'RISK_SETTING', 'CLOSE_LOOP_REFUND_EXIT_LIMIT'),
            isSearchFlow,
            false,
            selectedEntity?.id,
          )}
          actionButtons={() => <></>}
          initialValues={{}}
          container={FormBox}
        />
      </ModBox>
      <ModBox show={false}>
        <TextNew title="No data found" color={'PRIMARY'} fontSize={16} fontWeight="BOLD" />
      </ModBox>
    </Box>
  )
}

export { RiskSettings }
